import {
  cibFacebook,
  cibApple,
  cibLine,
  cibGmail,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cibGithub,
  cibStackoverflow,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibStripe,
  cibPaypal,
  cibGooglePay,
  cibCcAmex,
  cibGoogle,
  cibFacebookF,
} from '@coreui/icons'
import { cifUs, cifBr, cifIn, cifFr, cifEs, cifPl, cifTh } from '@coreui/icons'
import {
  cilColorBorder,
  cilScreenDesktop,
  cilBirthdayCake,
  cilArrowRight,
  cilBurger,
  cilInput,
  cilCart,
  cilActionRedo,
  cilPhone,
  cilSitemap,
  cilWallet,
  cilCreditCard,
  cilGift,
  cilBan,
  cilBasket,
  cilBell,
  cilCalculator,
  cilCalendar,
  cilCloudDownload,
  cilChartPie,
  cilCheck,
  cilQrCode,
  cilChevronBottom,
  cilChevronTop,
  cilCheckCircle,
  cilCommentSquare,
  cilCursor,
  cilDrop,
  cilDollar,
  cilEnvelopeClosed,
  cilEnvelopeOpen,
  cilEuro,
  cilGlobeAlt,
  cilGrid,
  cilFile,
  cilJustifyCenter,
  cilLaptop,
  cilLayers,
  cilLightbulb,
  cilList,
  cilLocationPin,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMoon,
  cilOptions,
  cilPencil,
  cilPeople,
  cilPuzzle,
  cilSettings,
  cilShieldAlt,
  cilSpeech,
  cilSpeedometer,
  cilStar,
  cilTask,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilBarChart,
  cilXCircle,
  cilAccountLogout,
  cilFastfood,
  cilFolderOpen,
  cilChart,
  cilChartLine,
  cilMoney,
  cilTag,
  cilSmilePlus,
  cilArrowThickFromRight,
  cilHistory,
  cilTrash,
  cilCircle,
  cilLanguage,
  cilClock,
  cilBook,
  cilCalendarCheck,
  cilAddressBook,
  cilRestaurant,
  cilLibrary,
  cilLibraryAdd,
  cilShortText,
  cilTags,
  cilCaretLeft,
  cilSave,
  cilX,
  cilSync,
  cilAlarm,
  cilWarning,
  cilHome
} from '@coreui/icons'

export const iconsSet = Object.assign(
  {},
  {
    cilColorBorder,
    cilScreenDesktop,
    cilBirthdayCake,
    cilTrash,
    cilHistory,
    cilArrowThickFromRight,
    cilArrowRight,
    cilBan,
    cilBasket,
    cilBell,
    cilBarChart,
    cilCalculator,
    cilCalendar,
    cilCloudDownload,
    cilChartPie,
    cilCheck,
    cilQrCode,
    cilChevronBottom,
    cilChevronTop,
    cilCheckCircle,
    cilCommentSquare,
    cilCursor,
    cilDrop,
    cilDollar,
    cilEnvelopeClosed,
    cilEnvelopeOpen,
    cilEuro,
    cilGlobeAlt,
    cilGrid,
    cilFile,
    cilJustifyCenter,
    cilLaptop,
    cilLayers,
    cilLightbulb,
    cilList,
    cilLocationPin,
    cilLockLocked,
    cilMagnifyingGlass,
    cilMoon,
    cilOptions,
    cilPencil,
    cilPeople,
    cilPuzzle,
    cilSettings,
    cilShieldAlt,
    cilSpeech,
    cilSpeedometer,
    cilStar,
    cilTask,
    cilUser,
    cilUserFemale,
    cilUserFollow,
    cilXCircle,
    cilCircle,
    cilLanguage,
    cilClock,
    cilLibrary,
    cilLibraryAdd,
    cilSync,
    cilAlarm,
    cilHome
  },
  {
    cifUs,
    cifTh,
    cifBr,
    cifIn,
    cifFr,
    cifEs,
    cifPl,
  },
  {
    cibFacebook,
    cibApple,
    cibLine,
    cibGmail,
    cibTwitter,
    cibLinkedin,
    cibFlickr,
    cibTumblr,
    cibXing,
    cibGithub,
    cibStackoverflow,
    cibYoutube,
    cibDribbble,
    cibInstagram,
    cibPinterest,
    cibVk,
    cibYahoo,
    cibBehance,
    cibReddit,
    cibVimeo,
    cibCcMastercard,
    cibCcVisa,
    cibStripe,
    cibPaypal,
    cibGooglePay,
    cibCcAmex,
    cilAccountLogout,
    cilFastfood,
    cilFolderOpen,
    cilChart,
    cilChartLine,
    cilMoney,
    cilTag,
    cilSmilePlus,
    cibGoogle,
    cibFacebookF,
    cilBurger,
    cilInput,
    cilCart,
    cilActionRedo,
    cilPhone,
    cilCreditCard,
    cilSitemap,
    cilWallet,
    cilGift,
    cilBook,
    cilCalendarCheck,
    cilAddressBook,
    cilRestaurant,
    cilLibrary,
    cilLibraryAdd,
    cilShortText,
    cilTags,
    cilCaretLeft,
    cilSave,
    cilX,
    cilWarning,
    cilHome
  }
)
